// LIB
import React from 'react';
import styled from 'styled-components';

// STYLES
import { colors, fontFamily, fontSize } from '../../Design_System/DesignSystem';

// COMPONENT
import { Text } from '../atoms/Text';

const Contact = () => {
  return (
    <Container>
      <Platform>
        <Text
          color={colors.tan}
          fontSize={fontSize.small}
          fontFamily={fontFamily.playfair}
          bold={false}
          justify={false}
        >
          <>
            <b>Github</b>
            <Url>: https://github.com/TristanLemire</Url>
          </>
        </Text>
      </Platform>
      <Platform>
        <Text
          color={colors.tan}
          fontSize={fontSize.small}
          fontFamily={fontFamily.playfair}
          bold={false}
          justify={false}
        >
          <>
            <b>Linkedin</b>
            <Url>: https://www.linkedin.com/in/tristan-lemire1/</Url>
          </>
        </Text>
      </Platform>
      <div>
        <Text
          color={colors.tan}
          fontSize={fontSize.small}
          fontFamily={fontFamily.playfair}
          bold={false}
          justify={false}
        >
          <>
            <b>Mail</b>
            <Url>: tristan.lemire.sio@gmail.com</Url>
          </>
        </Text>
      </div>
    </Container>
  );
};

const Container = styled.div`
  max-width: 400px;
  margin: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;
`;

const Platform = styled.div`
  margin-bottom: 10px;
`;

const Url = styled.span`
  @media (max-width: 390px) {
    display: none;
  }
`;

export default Contact;
